<template>
  <div id="app">
    <header-wrapper></header-wrapper>
    <router-view :key="$route.fullPath" />

    <div
      class="modal fade"
      id="main-msg-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      style="z-index:99999"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-align">Notification</h5>
          </div>
          <div class="modal-body">
            <br>
            <div
              class="alert text-center"
              :class="' alert-'+$root.msgBox.alertType"
              role="alert"
              v-html="$root.msgBox.message"
            ></div>
          </div>
          <div class="modal-footer text-center">
            <button type="button" class="btn btn-primary" data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import "@/assets/css/layout.css";
import "@/assets/css/menu.css";
//import ShapeOverlays from "@/assets/js/HamburgerMenu.js";
import HeaderWrapper from "@/components/HeaderWrapper.vue";

export default {
  name: "App",
  components: {
    HeaderWrapper
  },
  mounted() {
    //this.initHambergerMenu();    
  },
  methods: {
    /*
    initHambergerMenu() {
      const elmHamburger = document.querySelector(".hamburger");
      const gNavItems = document.querySelectorAll(".global-menu__item");
      const elmOverlay = document.querySelector(".shape-overlays");
      const overlay = new ShapeOverlays(elmOverlay);

      elmHamburger.addEventListener("click", () => {
        if (overlay.isAnimating) {
          return false;
        }
        overlay.toggle();
        if (overlay.isOpened === true) {
          elmHamburger.classList.add("is-opened-navi");
          for (var i = 0; i < gNavItems.length; i++) {
            gNavItems[i].classList.add("is-opened");
          }
        } else {
          elmHamburger.classList.remove("is-opened-navi");
          for (var i = 0; i < gNavItems.length; i++) {
            gNavItems[i].classList.remove("is-opened");
          }
        }
      });
    }
    */
  }
};
</script>

<style lang="stylus">
.slider-content{
  overflow-x : hidden;
  overflow-y : hidden;
  height : 100vh;
  position: fixed;
  left:0px;
  position:0px;        
}
.slider-container{
  overflow-x : hidden;
  overflow-y : hidden;
  height: 100vh!important;
  width: 100%!important;  
}
.nav-wrapper {
  z-index: 91;
  position: fixed;
}
/* width */
/*
*/
div.home{
  width: 100%;
  //height: calc(100vh + 100vh);
  height: 100vh;
  //overflow: scroll;
  overflow: hidden;
  /* scrollbar-width: 0px!important;*/
}
body{
  /*overflow: hidden;*/
  /*overflow-y: auto;*/
}

</style>
